import BackupIcon from '@mui/icons-material/Backup';
import BugReportIcon from '@mui/icons-material/BugReport';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import PageviewIcon from '@mui/icons-material/Pageview';

export const TAX_RATE = 0.1;
// export const EBS_PRICE_PER_GB = 23.4;

export const INSTANCE_PLANS = {
  NANO: 'NANO',
  MICRO: 'MICRO',
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
};

export const INSTANCE_CATEGORY = {
  LEGACY: 'LEGACY',
  COMMUNITY: 'COMMUNITY',
  STANDARD: 'STANDARD',
  ENTERPRISE: 'ENTERPRISE',
};

export const ASSISTANT_PLANS = {
  NANO: 'NANO',
  MICRO: 'ENTRY',
  SMALL: 'PRO',
};

export const PLAN_LIST = [
  {
    name: 'community',
    description: 'features.desc.community',
    type: INSTANCE_PLANS.SMALL,
    category: INSTANCE_CATEGORY.COMMUNITY,
    price: 0,
    storage: 314572800, // 300MB
    features: [
      {
        icon: <DescriptionOutlinedIcon />,
        content: 'features.docs.community',
      },
      {
        icon: <BackupIcon />,
        content: 'features.backup.community',
      },
      {
        icon: <DeviceHubIcon />,
        content: 'features.cidrs.community',
      },
    ],
  },
  {
    name: 'entry',
    description: 'features.desc.standard',
    type: INSTANCE_PLANS.SMALL,
    category: INSTANCE_CATEGORY.STANDARD,
    price: 10000,
    storage: 1073741824, // 1GB
    features: [
      {
        icon: <DescriptionOutlinedIcon />,
        content: 'features.docs.entry',
      },
      {
        icon: <BackupIcon />,
        content: 'features.backup.entry',
      },
      {
        icon: <PageviewIcon />,
        content: 'features.crawler.oneSeed',
      },
      {
        icon: <DeviceHubIcon />,
        content: 'features.cidrs.entry',
      },
    ],
  },
  {
    name: 'pro',
    description: 'features.desc.standard',
    type: INSTANCE_PLANS.MEDIUM,
    category: INSTANCE_CATEGORY.STANDARD,
    price: 50000,
    storage: 10737418240, // 10 GB
    features: [
      {
        icon: <DescriptionOutlinedIcon />,
        content: 'features.docs.pro',
      },
      {
        icon: <BackupIcon />,
        content: 'features.backup.pro',
      },
      {
        icon: <PageviewIcon />,
        content: 'features.crawler.oneSeed',
      },
      {
        icon: <BugReportIcon />,
        content: 'features.virusScan',
      },
      {
        icon: <DeviceHubIcon />,
        content: 'features.cidrs.pro',
      },
    ],
  },
  {
    name: 'elite',
    description: 'features.desc.standard',
    type: INSTANCE_PLANS.LARGE,
    category: INSTANCE_CATEGORY.STANDARD,
    price: 100000,
    storage: 42949672960, // 40GB
    features: [
      {
        icon: <DescriptionOutlinedIcon />,
        content: 'features.docs.elite',
      },
      {
        icon: <BackupIcon />,
        content: 'features.backup.elite',
      },
      {
        icon: <PageviewIcon />,
        content: 'features.crawler.oneSeed',
      },
      {
        icon: <BugReportIcon />,
        content: 'features.virusScan',
      },
      {
        icon: <DeviceHubIcon />,
        content: 'features.cidrs.elite',
      },
    ],
  },
];
